import { render, staticRenderFns } from "./createdoc_payment_trans_one.vue?vue&type=template&id=7aed0d45&lang=true&"
import script from "./createdoc_payment_trans_one.vue?vue&type=script&lang=js&"
export * from "./createdoc_payment_trans_one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports